import * as React from 'react'
import { observer } from 'mobx-react'

import { Section, SectionItem } from '../../components/Section'
import SpousalProfileViewModel from '../SpousalProfile/SpousalProfileViewModel'

interface Props {
  vm: SpousalProfileViewModel
}

export default observer(function PersonalProfile({ vm }: Props) {
  if (!vm.profile) {
    return <></>
  }

  return (
    <div>
      <Section
        title="Spousal Information"
        bordered
        loading={vm.activate.pending}
      >
        <SectionItem
          label="Name"
          value={vm.profile?.personalInfo?.fullName}
          isSensitive
        />

        <SectionItem
          label="Date of birth"
          value={vm.profile?.personalInfo?.dateOfBirth}
          isSensitive
        />

        <SectionItem
          label="Occupation"
          value={vm.profile?.occupation}
          isSensitive
        />

        <SectionItem
          label="SSN or ITIN"
          value={vm.profile?.personalInfo?.personalTaxpayerIdentificationNumber}
          maskedValue={
            vm.profile?.personalInfo
              ?.personalTaxpayerIdentificationNumberDisplay
          }
          isSensitive
        />
      </Section>
    </div>
  )
})
